import { AddMemberFormDataUpdated } from "../components/forms/AddMemberForm";
import { UpdateMemberFormDataUpdated } from "../components/forms/UpdateMemberForm";

export const initialFormValuesNew: AddMemberFormDataUpdated = {
  first_name: "",
  last_name: "",
  email: "",
  mobile: "",
  gender: "",
  dob_date: "",
  zip: "",
  country_of_residence: "",
  storecountrycode: "",
  customer_status: "Active",
  shipping_address: "",
  delivery_city: "",
  salutation: "Mr",
  subscr_for_news: false,
  subscr_for_mkt: false,
  email_marketing: false,
  heard_about_us: "",
  occupation: "",
  unit_no: "",
  street_address: "",
  is_birthday_month: false,
  source_tag: "",
  member_type: "",
  password: "",
  interest: "",
  isInternalStaff: "",
  emailNotification: false,
  pushNotification: false,
  other_heard_about_us: "",
  iuNumber1: "",
  iuNumber2: "",
  licensePlate1: "",
  licensePlate2: "",
  currentSlab: "",
  isinternalstaffdiamo: "",
  isinternstaffgold: "",
  isinternalsatffquit: ""
};

export const updateFormValuesNew: AddMemberFormDataUpdated = {
  first_name: "",
  last_name: "",
  email: "",
  mobile: "",
  gender: "",
  dob_date: "",
  zip: "",
  country_of_residence: "",
  storecountrycode: "",
  customer_status: "",
  shipping_address: "",
  delivery_city: "",
  salutation: "",
  subscr_for_news: true,
  subscr_for_mkt: false,
  email_marketing: false,
  heard_about_us: "",
  occupation: "",
  unit_no: "",
  street_address: "",
  is_birthday_month: false,
  source_tag: "",
  member_type: "",
  password: "",
  interest: "",
  isInternalStaff: "",
  emailNotification: false,
  pushNotification: false,
  other_heard_about_us: "",
  iuNumber1: "",
  iuNumber2: "",
  licensePlate1: "",
  licensePlate2: "",
  currentSlab: "",
  isinternalstaffdiamo: "",
  isinternstaffgold: "",
  isinternalsatffquit: ""
};
